import { render, staticRenderFns } from "./main.vue?vue&type=template&id=45ae89d0&"
import script from "./main.vue?vue&type=script&lang=jsx&"
export * from "./main.vue?vue&type=script&lang=jsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_a2ryrgrddytsl2onh2hza74dqa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\comm\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ae89d0')) {
      api.createRecord('45ae89d0', component.options)
    } else {
      api.reload('45ae89d0', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=45ae89d0&", function () {
      api.rerender('45ae89d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/dg-tree/src/main.vue"
export default component.exports